import { type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { Container } from '@treams/treams-ui/common/Container';
import { FlexGap } from '@treams/treams-ui/common/FlexGap';
import { Jumbo } from '@treams/treams-ui/common/Jumbo';
import { tokens } from '@treams/treams-ui/theme/tokens';

import { GenderGapTable } from './GenderGapTable';
import { RewardFunctions } from './RewardFunctions';
import { useRewardAnalytics } from './useRewardAnalytics';

export function RewardAnalytics(props: { headerFooter?: ReactNode }) {
	const { t } = useTranslation();
	const { loading, functions, genderGap } = useRewardAnalytics();

	return (
		<>
			<Jumbo title={t('analytics.overview.title')} footer={props.headerFooter} wide={true} />
			<Container py={4} wide={true} minWidth={0}>
				{loading ? (
					<RewardFunctions.Skeleton />
				) : (
					<FlexGap flexDirection="column" gap={tokens.gap.group}>
						<RewardFunctions functions={functions ?? []} />
						{genderGap && <GenderGapTable genderGap={genderGap} />}
					</FlexGap>
				)}
			</Container>
		</>
	);
}
